/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2018, 2021
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

define([], (
) => {
	class Widget {
		constructor(widget) {
			this.widget = widget;
		}

		getAPI() {
			return this;
		}

		getId() {
			return this.widget.getId();
		}

		getEventGroupId() {
			return this.widget.getEventGroupId();
		}

		getScope() {
			return this.widget.getContainerPageId();
		}

		/**
		 * @deprecated  APIs should not know about their parent
		 */
		getLayoutAPI() {
			return this.widget.getLayoutAPI();
		}

		getType() {
			return this.widget.getType();
		}

		/**
		 * @deprecated
		 * @todo this is the only implementation of getProperties.  Work required to move to the new one
		 */
		getProperties(overrideTheme) {
			return this.widget.getProperties(overrideTheme);
		}
		/**
		 * @deprecated
		 */
		getProperty(propertyName) {
			return this.widget.getProperty(propertyName);
		}

		getPropertyLayoutList() {
			return this.widget.getPropertyLayoutList();
		}

		getPropertyList() {
			return this.widget.getPropertyList();
		}

		getFeature(featureId) {
			return this.widget.getFeature(featureId);
		}

		getContextToolbarItems() {
			return this.widget.getContextToolbarItems();
		}

		/**
		 * @deprecated use {@link WidgetAPI#getErrorDetails}
		 */
		getError() {
			return this.widget.getError();
		}

		getErrorDetails() {
			return this.hasError() ? {
				errorMessage: this.widget.getError()
			} : null;
		}

		hasError() {
			return this.widget.hasError();
		}

		hasWarning() {
			return this.widget.hasWarning();
		}

		/**
		 * @deprecated Clearing of the error should be handled by a render call and the render sequence
		 */
		clearError() {
			this.widget.clearError();
		}

		on(eventName, handler, context) {
			return this.widget.on(eventName, handler, context);
		}

		off(eventName, handler, context) {
			return this.widget.off(eventName, handler, context);
		}

		isWidgetMaximized() {
			return this.widget.isWidgetMaximized();
		}

		isContextualGridEnabled() {
			return this.widget.isContextualGridEnabled();
		}

		setFeatureEnabled(featureId, isEnabled) {
			return this.widget.setFeatureEnabled(featureId, isEnabled);
		}

		destroy() {
			this.widget = null;
		}
	}

	return Widget;
});
